import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaYoutube,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import SubscribePopup from "../common/SubscribePopup";
import M2TLogo from "../common/M2TLogo";
import M2THeroBanner from "../../components/LandingPage/M2THeroBanner";

const linkClass =
  "relative transition text-gray-300 hover:text-purple-400 focus:text-purple-500 focus:outline-none after:content-[''] after:absolute after:left-0 after:-bottom-1 after:w-0 after:h-[2px] after:bg-gradient-to-r after:from-purple-500 after:to-blue-500 hover:after:w-full focus:after:w-full after:transition-all after:duration-300";
const highlightSocial =
  "transition-all duration-200 hover:scale-125 focus:scale-125 focus:outline-none";

export default function FooterLinks() {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <footer
      className="w-full bg-[#0B0F19] px-4 pb-4 pt-60 font-sans text-white md:px-12"
      style={{
        backgroundImage: "url('/assets/images/Footer.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="-mt-72 py-24">
        <M2THeroBanner />
      </div>
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 md:grid-cols-5">
        {/* --- COMPANY + SOCIALS --- */}
        <div className="flex flex-col gap-4">
          <div className="mb-1 flex items-center gap-2">
            {/* Logo scales with screen */}
            <M2TLogo className="h-[48px] sm:h-[56px] md:h-[64px]" />
          </div>
          <div className="text-sm leading-snug text-gray-300">
            Building the world's largest trusted financial marketplace —
            unifying verified traders, investors, coders, educators, and market
            professionals.
          </div>
          <div className="mt-2 flex gap-2 text-xl">
            <a
              href="https://youtube.com/@million2trillionofficial?si=fiCg78phVOU9A2yA"
              target="_blank"
              rel="noopener noreferrer"
              className={highlightSocial}
            >
              <FaYoutube className="hover:text-red-600" />
            </a>
            <a
              href="https://www.linkedin.com/company/million2trillionofficial/"
              target="_blank"
              rel="noopener noreferrer"
              className={highlightSocial}
            >
              <FaLinkedinIn className="hover:text-blue-700" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61576664019656"
              target="_blank"
              rel="noopener noreferrer"
              className={highlightSocial}
            >
              <FaFacebookF className="hover:text-blue-600" />
            </a>
            <a
              href="https://www.instagram.com/million2trillionofficial"
              target="_blank"
              rel="noopener noreferrer"
              className={highlightSocial}
            >
              <FaInstagram className="hover:text-pink-500" />
            </a>
            <a
              href="https://x.com/M2Tofficial?s=09"
              target="_blank"
              rel="noopener noreferrer"
              className={highlightSocial}
            >
              <FaTwitter className="hover:text-blue-400" />
            </a>
            <a
              href="https://www.tiktok.com/@m2t_official_"
              target="_blank"
              rel="noopener noreferrer"
              className={highlightSocial}
            >
              <SiTiktok className="hover:text-[#69C9D0]" />
            </a>
          </div>
        </div>

        {/* --- USEFUL LINKS --- */}
        <div>
          <h4 className="mb-3 font-semibold text-purple-400">Useful Links</h4>
          <ul className="space-y-2 text-sm text-gray-300">
            <li>
              <Link to="/about-us" className={linkClass}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/team" className={linkClass}>
                Team
              </Link>
            </li>
            <li>
              <Link to="/careers" className={linkClass}>
                Careers
              </Link>
            </li>
            <li>
              <Link to="/blog" className={linkClass}>
                Blog
              </Link>
            </li>
            <li>
              <Link to="/founderjourney" className={linkClass}>
                Founder Story
              </Link>
            </li>
            <li>
              <Link to="/solutions" className={linkClass}>
                Solutions
              </Link>
            </li>
            <li>
              <Link to="/productzones" className={linkClass}>
                Product Zones
              </Link>
            </li>
            <li>
              <Link to="/news" className={linkClass}>
                News
              </Link>
            </li>
          </ul>
        </div>

        {/* --- LEGAL --- */}
        <div>
          <h4 className="mb-3 font-semibold text-purple-400">Legal</h4>
          <ul className="space-y-2 text-sm text-gray-300">
            <li>
              <Link to="/legal/terms-of-use" className={linkClass}>
                Terms of Use
              </Link>
            </li>
            <li>
              <Link to="/legal/privacy-policy" className={linkClass}>
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/legal/refund-policy" className={linkClass}>
                Refund Policy
              </Link>
            </li>
            <li>
              <Link to="/legal/cookie-policy" className={linkClass}>
                Cookie Policy
              </Link>
            </li>
            <li>
              <Link to="/legal/kyc-policy" className={linkClass}>
                KYC & Compliance
              </Link>
            </li>
            <li>
              <Link to="/legal/risk-disclaimer" className={linkClass}>
                Risk Disclaimer
              </Link>
            </li>
            <li>
              <Link to="/legal/community-guidelines" className={linkClass}>
                Community Guidelines
              </Link>
            </li>
          </ul>
        </div>
        {/* --- SUPPORT --- */}
        <div>
          <h4 className="mb-3 font-semibold text-purple-400">
            Support & Teams
          </h4>
          <ul className="space-y-2 text-sm text-gray-300">
            <li>
              {/* ✅ now navigates to /contact, not mail client */}
              <Link to="/contact" className={linkClass}>
                Contact Office
              </Link>
            </li>
            <li>
              <a
                href="mailto:founder@million2trillion.com?cc=satbir@million2trillion.com"
                className={linkClass}
              >
                Contact Founders
              </a>
            </li>

            {/* ✅ Grouped WhatsApp Support Block with Icons */}
            <li className="mt-2">
              <span className="mb-1 block font-semibold text-purple-300">
                WhatsApp Support
              </span>
              <div className="flex flex-col space-y-1">
                <a
                  href="https://wa.me/255789745684"
                  className={`flex items-center gap-2 text-white ${linkClass}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/assets/icons/whatsapp.svg"
                    alt="WhatsApp"
                    className="h-4 w-4 opacity-90"
                  />
                  +255-789745684
                </a>
                <a
                  href="https://wa.me/255756888864"
                  className={`flex items-center gap-2 text-white ${linkClass}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/assets/icons/whatsapp.svg"
                    alt="WhatsApp"
                    className="h-4 w-4 opacity-90"
                  />
                  +255-756888864
                </a>
              </div>
            </li>

            <li>
              <Link to="/faq" className={linkClass}>
                FAQs
              </Link>
            </li>
          </ul>
        </div>

        {/* --- OFFICES & ENTITY --- */}
        <div>
          <h4 className="mb-3 font-semibold text-purple-400">
            Offices & Entity
          </h4>
          <div className="space-y-1 text-sm text-gray-300">
            <div>
              <span className="font-semibold text-white">Head Office:</span>{" "}
              United States
            </div>
            <div>
              <span className="font-semibold text-white">Regional:</span> UAE
              (Middle East & Africa)
            </div>
            <div>
              <span className="font-semibold text-white">Asia Region:</span>{" "}
              India
            </div>
            <div>
              <span className="font-semibold text-white">Entity:</span>{" "}
              Million2Trillion Inc.
            </div>
            <div>
              <span className="font-semibold text-white">Registration:</span>{" "}
              Under Process
            </div>
          </div>
        </div>
      </div>

      {/* --- SECURITY, TRUST & PLATFORM DISCLOSURE --- */}
      <div className="mx-auto mt-10 max-w-6xl border-t border-[#222644] pt-6 text-[11px] leading-relaxed text-gray-400">
        <p className="mb-3">
          <strong className="text-gray-300">Mission Statement:</strong>{" "}
          Million2Trillion (M2T) is being built as a{" "}
          <strong>scam-free professional market network</strong>. Our core
          mission is to create a highly secure, transparent, and trust-driven
          environment where verified professionals can connect, collaborate, and
          grow without exposure to fraudulent actors or misleading platforms.
        </p>

        <p className="mb-3">
          <strong className="text-gray-300">
            Security-First Architecture:
          </strong>{" "}
          User security, data protection, and identity verification are
          foundational pillars of the Million2Trillion platform. We prioritize
          strict access controls, KYC-supported verification layers, monitored
          integrations, and controlled visibility to ensure only genuine
          participants engage within the ecosystem.
        </p>

        <p className="mb-3">
          <strong className="text-gray-300">
            Platform Role Clarification:
          </strong>
          Million2Trillion is a technology and infrastructure platform. We do
          not act as a broker, dealer, exchange, custodian, or financial
          intermediary. All trading, transactions, and financial services are
          conducted directly on third-party broker or service provider
          platforms.
        </p>

        <p className="mb-3">
          <strong className="text-gray-300">API & Broker Integrations:</strong>{" "}
          Broker websites, tools, dashboards, or services displayed within
          Million2Trillion are integrated through secure APIs, widgets, or
          iframe technologies for discovery, comparison, and workflow
          efficiency. Million2Trillion does not interfere with execution,
          pricing, fund handling, or broker operations.
        </p>

        <p className="mb-3">
          <strong className="text-gray-300">
            Verified Connections & Quality Leads:
          </strong>
          Our platform is designed to connect brokers and service providers with
          <strong>verified, KYC-aware users</strong>, improving lead quality,
          reducing fraud risk, and eliminating low-intent or anonymous traffic
          common in traditional advertising channels.
        </p>

        <p className="mb-3">
          <strong className="text-gray-300">Risk Disclaimer:</strong>{" "}
          Participation in financial markets involves risk and may not be
          suitable for all users. Million2Trillion does not provide investment
          advice or guarantee outcomes. Users should independently assess risks
          and consult licensed professionals where necessary.
        </p>

        <p className="mb-3">
          <strong className="text-gray-300">Public Beta Notice:</strong>{" "}
          Million2Trillion is currently operating in a controlled beta phase.
          Public platform access is scheduled for release on{" "}
          <strong>June 29</strong>. Features, integrations, and availability may
          evolve as part of our security-first rollout strategy.
        </p>

        <p>
          <strong className="text-gray-300">Corporate Status:</strong>{" "}
          Million2Trillion Inc. entity registrations and jurisdictional
          structuring are actively under process. Transparency and compliance
          alignment remain a priority throughout this phase.
        </p>
      </div>

      {/* Newsletter Section */}
      <div className="mb-3 mt-10 border-t border-[#222644]"></div>
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 pb-2 md:flex-row">
        <div className="text-xs text-gray-400">
          &copy; {new Date().getFullYear()} Million2Trillion. All rights
          reserved.
        </div>

        <button
          onClick={() => setShowPopup(true)}
          className="rounded-full bg-gradient-to-r from-purple-500 to-blue-500 px-5 py-2 text-xs font-semibold text-white transition hover:from-purple-600 hover:to-blue-600"
        >
          Subscribe to Newsletter
        </button>
      </div>

      {/* Newsletter Popup */}
      <SubscribePopup
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        source="footer"
      />
    </footer>
  );
}
